import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <main className="min-h-screen bg-[#f7f8fb] text-[#0E1530]">
      <nav className="h-16 border-b border-[#e5e8ee] bg-white/90 backdrop-blur px-6 md:px-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 no-underline">
          <img src="/workshopmu-logo.svg" alt="WorkshopMU" className="h-9 w-9" />
          <span className="font-bold text-lg tracking-tight">
            Workshop<span className="text-[#FF6A1F]">MU</span>
          </span>
        </Link>
        <div className="hidden md:flex items-center gap-9 text-sm font-medium">
          <a href="/#fitur" className="text-[#5A6178] hover:text-[#0E1530]">Fitur</a>
          <a href="/#cara-kerja" className="text-[#5A6178] hover:text-[#0E1530]">Cara Kerja</a>
          <a href="/#marketing-kpi" className="text-[#5A6178] hover:text-[#0E1530]">Marketing KPI</a>
          <a href="/#harga" className="text-[#5A6178] hover:text-[#0E1530]">Harga</a>
          <Link to="/tentang-kami" className="text-[#5A6178] hover:text-[#0E1530]">Tentang Kami</Link>
        </div>
        <div className="flex items-center gap-3 text-sm font-semibold">
          <Link to="/login" className="text-[#5A6178] hover:text-[#0E1530]">Masuk</Link>
          <Link to="/register" className="rounded-lg bg-[#1E4FD8] px-4 py-2 text-white hover:bg-[#1A45BF]">Coba Gratis</Link>
        </div>
      </nav>

      <section className="mx-auto max-w-5xl px-6 py-16 md:py-24">
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.18em] text-[#1E4FD8]">Tentang Kami</p>
        <h1 className="max-w-3xl text-4xl md:text-5xl font-extrabold leading-tight tracking-tight">
          WorkshopMU dibuat untuk membantu workshop detailing dan PPF bekerja lebih rapi dari hari pertama.
        </h1>
        <p className="mt-6 max-w-3xl text-base md:text-lg leading-8 text-[#5A6178]">
          Kami membangun WorkshopMU sebagai sistem operasional yang fokus pada kebutuhan bengkel modern:
          booking, layanan berjalan, stok material, HPP, dokumen, garansi, dan laporan. Tujuannya sederhana:
          data bengkel tidak tercecer, keputusan owner lebih jelas, dan proses harian tim lebih mudah diikuti.
        </p>

        <div className="mt-12 grid gap-4 md:grid-cols-3">
          {[
            ['Fokus operasional', 'Alur dibuat dari kebutuhan kerja bengkel: pelanggan masuk, layanan diproses, stok terpakai, laporan terbentuk.'],
            ['Dibangun bertahap', 'Fitur dirilis phase by phase supaya stabil untuk pre-release dan siap berkembang bersama tenant awal.'],
            ['Transparan', 'Fitur yang belum siap tidak dijanjikan sebagai fitur aktif. Payment juga tetap nonaktif sampai integrasi final.'],
          ].map(([title, text]) => (
            <div key={title} className="rounded-xl border border-[#e5e8ee] bg-white p-6">
              <h2 className="text-base font-bold">{title}</h2>
              <p className="mt-3 text-sm leading-6 text-[#5A6178]">{text}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-3">
          <div className="flex items-center gap-2 text-sm font-semibold text-[#5A6178]">
            <span>Kontak kami lewat WhatsApp</span>
            <a
              href="https://wa.me/6287887754702"
              target="_blank"
              rel="noreferrer"
              aria-label="Hubungi kami via WhatsApp"
              title="Hubungi kami via WhatsApp"
              className="inline-flex h-12 w-12 items-center justify-center rounded-xl border border-[#d9e3fc] bg-white text-[#16a34a] hover:border-[#16a34a] hover:bg-[#f0fdf4]"
            >
              <svg aria-hidden="true" viewBox="0 0 32 32" className="h-7 w-7 fill-current">
                <path d="M16.03 4C9.4 4 4.02 9.34 4.02 15.91c0 2.1.56 4.15 1.62 5.95L4 28l6.3-1.63a12.06 12.06 0 0 0 5.73 1.45C22.66 27.82 28 22.48 28 15.91S22.66 4 16.03 4Zm0 21.8c-1.78 0-3.52-.48-5.04-1.39l-.36-.21-3.74.97.99-3.62-.24-.37a9.7 9.7 0 0 1-1.5-5.27c0-5.45 4.44-9.89 9.89-9.89 5.43 0 9.85 4.44 9.85 9.89s-4.42 9.89-9.85 9.89Zm5.42-7.39c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.95 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.46-.88-.78-1.48-1.75-1.65-2.05-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.05 1.03-1.05 2.5s1.07 2.9 1.22 3.1c.15.2 2.11 3.22 5.1 4.51.71.31 1.27.49 1.7.63.72.23 1.37.2 1.89.12.58-.09 1.76-.72 2.01-1.41.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35Z" />
              </svg>
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
